const alternativePhonesToArrayOfObjects = (alternativePhones, formValuesAlternativePhones) => {
    let arrayOfalternativePhones = [];

    alternativePhones.map(altPhone => {
        const key = altPhone.id
        const altPhoneNumber = formValuesAlternativePhones[`phoneCode${key}`] + formValuesAlternativePhones[`phoneNumber${key}`]
        const altPhoneCompany = formValuesAlternativePhones[`phoneCompany${key}`]

        arrayOfalternativePhones = [...arrayOfalternativePhones,
        {
            number: altPhoneNumber,
            company: altPhoneCompany
        }]
    })

    return arrayOfalternativePhones
}

const alternativePhonesToString = alternativePhones => {

    let string = '';
    alternativePhones.forEach(phone => {
        string += `${phone.number}|${phone.company}|`
    });

    return string
}

export { alternativePhonesToArrayOfObjects, alternativePhonesToString }